import { render, staticRenderFns } from "./change.vue?vue&type=template&id=0a376654&scoped=true"
import script from "./change.vue?vue&type=script&lang=js"
export * from "./change.vue?vue&type=script&lang=js"
import style0 from "./change.vue?vue&type=style&index=0&id=0a376654&prod&scoped=true&lang=css"
import style1 from "@/assets/css/app.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/css/unique.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/assets/css/payment.css?vue&type=style&index=3&id=0a376654&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a376654",
  null
  
)

export default component.exports